module.exports = __webpack_public_path__ + "img/文字识别.7686afc8.png";